import { useEffect } from 'react';

import { isEmpty } from 'lodash';
import { useDispatch } from 'react-redux';

import {
  retrieveDistrictDetails,
  retrieveOrganizationContext,
  retrieveUserContext,
  retrieveUserDetails,
  setModuleAccessLoaded,
} from 'actions/user';

const useUserContext = ({
  data: { affiliations, isLoggedIn, isMember, moduleAccess },
}) => {
  const dispatch = useDispatch();

  const loadContext = async () => {
    if (isEmpty(moduleAccess) && isLoggedIn) {
      await dispatch(retrieveUserContext());
      await dispatch(retrieveUserDetails());
      await dispatch(retrieveDistrictDetails());
    }

    if (isEmpty(affiliations) && isLoggedIn && isMember) {
      await dispatch(retrieveOrganizationContext());
    }

    dispatch(setModuleAccessLoaded(true));
  };

  useEffect(() => {
    loadContext();
  }, []);
};

export default useUserContext;
